/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Home_Quotes_Turing_TitleInputs */



/**

* @param {Home_Quotes_Turing_TitleInputs} inputs
* @param {{ locale?: "es" }} options
* @returns {LocalizedString}
*/
export const home_quotes_turing_title = /** @type {((inputs?: Home_Quotes_Turing_TitleInputs, options?: { locale?: "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Home_Quotes_Turing_TitleInputs, { locale?: "es" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return /** @type {LocalizedString} */ ("Inventor de la computadora moderna")
});